import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="day-month-select"
export default class extends Controller {

  static targets = ["day", "month"]
  
  onMonthChange(e) {

    // Set the variables
    const month = e.target.value
    const nonLeapYear = 2023
    const daysInMonth = new Date(nonLeapYear, month, 0).getDate()
    const currentDay = parseInt(this.dayTarget.value, 10)

    // If the current day is greater than the days in the month, clear it
    if (currentDay > daysInMonth) this.dayTarget.value = ""
    
    // Clear the day options
    this.dayTarget.innerHTML = ""
    
    // Create an array of days
    const days = Array.from({ length: daysInMonth }, (_, i) => i + 1)
    
    // Add a blank option
    this.dayTarget.appendChild(document.createElement("option"))
    
    // For each day, create an option and append it to the day select
    days.forEach((day) => {
      const option = document.createElement("option")
      option.value = day
      option.textContent = day
      this.dayTarget.appendChild(option)
    })

    // Reselect the current day
    this.dayTarget.value = (currentDay > daysInMonth) ? "" : currentDay
    
  }
  
}
